export default __webpack_public_path__ + "static/media/robot.7ebd9df7.svg";